import { useRouter } from "next/router";
import { useContractReads } from "wagmi";
import useAccount from "@/hooks/useAccount";
import { validatorContracts } from "@/services/contract";

export default function useMintReferral(chainId: number) {
  const router = useRouter();
  const { validatorId, lieutenantAddress, ref } = router.query;
  const isOKX = ref === "okx";
  const { address } = useAccount();

  let vid: undefined | number = parseInt(validatorId as string);
  if (isNaN(vid)) {
    vid = undefined;
  }

  const contract = validatorContracts[chainId];

  const { data } = useContractReads({
    contracts:
      typeof vid !== "undefined" && lieutenantAddress
        ? [
            {
              ...contract,
              functionName: "validatorMap",
              args: [vid, lieutenantAddress],
            } as any,
          ]
        : [],
  });

  return {
    hasParamLieutenant: typeof vid !== "undefined" && lieutenantAddress,
    isValidLieutenant: !!data?.[0] && address !== lieutenantAddress,
    validatorId: isOKX
      ? "1"
      : typeof vid === "undefined"
      ? undefined
      : String(vid),
    lieutenantAddress: lieutenantAddress as string | undefined,
    ref: ref as string | undefined,
    isOKX,
  };
}
